import service from '@/store/services/reporte-salidas-service';
import Jsona from 'jsona';

const jsona = new Jsona();

export const state = () => ({
  list: {},
  resumen: {},
  salida: {},
  reporte: {},
  meta: {},
  url: null
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESUMEN: (state, resumen) => {
    state.resumen = resumen;
  },
  SET_RESOURCE: (state, salida) => {
    state.salida = salida;
  },
  SET_REPORT: (state, reporte) => {
    state.reporte = reporte;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  }
};

export const actions = {
  list({commit, dispatch}, params = {}) {
    return service.list(params, this.$axios)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  getVentaPorCorrida({commit, dispatch}, params) {
    return service.getVentaPorCorrida(params, this.$axios)
      .then((salida) => { commit('SET_RESOURCE', salida); });
  },

  getReporte({ commit, dispatch }, reporte) {
      return service.getReporte(reporte, this.$axios);
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.total,
  getVentaPorCorrida: state => state.salida,
  reporte: state => state.reporte,
  url: state => state.url
};

const reporte_salidas = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default reporte_salidas;
